<div class="or-p-16-px or-pt-40-px or-bg-shade">
  <div class="or-head-xs or-color-secondary-2 or-mb-12-px">Opcje</div>

  <div
    (click)="sendMessage()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="contact" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md">Wyślij wiadomość</div>
  </div>

  <div
    (click)="reportProfile()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="card-red" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md">Zgłoś profil</div>
  </div>
</div>
